import React from "react";
import styles from "../styles/AdminLayout.module.css";

export function AdminTopBar({ currentItem, onMenuClick, onLogout }) {
  return (
    <header className={styles.topbar}>
      <div className={styles.topbarPrimary}>
        <button
          type="button"
          className={styles.menuButton}
          onClick={onMenuClick}
          aria-label="Открыть навигацию"
        >
          Меню
        </button>
        <div className={styles.topbarCopy}>
          <div className={styles.topbarEyebrow}>Админ-панель</div>
          <h1 className={styles.topbarTitle}>{currentItem?.label || "Админка"}</h1>
          {currentItem?.description ? (
            <p className={styles.topbarDescription}>{currentItem.description}</p>
          ) : null}
        </div>
      </div>

      <div className={styles.topbarActions}>
        <button type="button" className={styles.topbarButton} onClick={onLogout}>
          Выйти
        </button>
      </div>
    </header>
  );
}

export default AdminTopBar;
